import React, { useEffect, useState } from 'react';

interface HeaderBarProps {
  companyNames?: any;
}

const HeaderBar: React.FC<HeaderBarProps> = ({ companyNames }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 480); // Galaxy S8+ is 360px wide
    };

    handleResize(); // initial check
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <div style={styles.wrapper}>
      <div style={styles.container}>
        <div style={styles.leftSection} className='headerLogoLine'>
          <img
            src='https://feel-eat.ch/app/images/feel-eat-logo-circle.png'
            alt='FeelEat Logo'
            className='feelEatBlackLogoPrint'
            style={{
              ...styles.logo,
              width: isMobile ? '36px' : '52px',
              height: isMobile ? '36px' : '52px',
            }}
          />
          <div
            style={{
              ...styles.line,
              width: isMobile ? '120px' : '350px',
              marginLeft: isMobile ? '8px' : '12px',
            }}
          />
        </div>
        {companyNames && (
          <div
            style={{
              ...styles.rightText,
              fontSize: isMobile ? '1.2rem' : '2.1rem',
              textAlign: isMobile ? 'right' : 'left',
              fontFamily: '"myGramaticaMedium", Arial, sans-serif',
              fontWeight: 400,
            }}
          >
            <strong>{companyNames.join(', ')}</strong>
          </div>
        )}
      </div>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  wrapper: {
    width: '100%',
    padding: '50px 50px 20px 50px'
  },
  container: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0',
    boxSizing: 'border-box',
    width: '100%',
  },
  leftSection: {
    display: 'flex',
    alignItems: 'center',
  },
  logo: {
    borderRadius: '50%',
    backgroundColor: 'black',
    padding: '10px',
  },
  line: {
    height: '1px',
    backgroundColor: 'black',
    fontWeight: 'bold',
  },
  rightText: {
    fontFamily: 'myGramaticaBold',
    fontWeight: 900,
    margin: 0,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
};

export default HeaderBar;
